/**
 * EN content for the "Saint-Paul-de-Vence" private excursion.
 *
 * Role: English translation of slugs/saint-paul-de-vence.ts, typed
 * `ExcursionPage` for the shared ExcursionSlugView.
 * Dependencies: slug-excursions (type), image. Slug mirrors FR (place name).
 */
import type { ExcursionPage } from "../slug-excursions";
import stpaulvence from "@/assets/images/excursions/destinations/st-paul-vence.jpeg";

const page: ExcursionPage = {
  slug: "saint-paul-de-vence",
  hero: {
    title: "Saint-Paul-de-Vence Excursion",
    subtitle:
      "Art, galleries and ramparts: a medieval gem near the French Riviera.",
    ctaPrimaryHref: "/en/reservation",
    ctaPrimaryLabel: "Book now",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "Get a quote",
    image: stpaulvence,
  },
  highlights: {
    title: "Highlights",
    items: [
      { text: "Ramparts and lanes of Saint-Paul-de-Vence" },
      { text: "Art galleries, studios and resident artists" },
      { text: "Maeght Foundation nearby (optional)" },
      { text: "Views over the back country and sea (on a clear day)" },
    ],
  },
  itinerary: {
    title: "Sample itinerary",
    steps: [
      {
        title: "Departure from Cannes",
        description: "A scenic road into the back country.",
      },
      {
        title: "Exploring the village",
        description: "Ramparts, squares, galleries.",
      },
    ],
  },
  practical: {
    title: "Practical information",
    items: [
      { label: "Duration", value: "3 to 5 hours" },
      { label: "Departure", value: "Cannes" },
      { label: "Footwear", value: "Cobbled ground, dress for comfort" },
      {
        label: "Option",
        value: "Visit to the Maeght Foundation (subject to opening hours)",
      },
    ],
  },
  seo: {
    title: "Saint-Paul-de-Vence Excursion | Private Chauffeur",
    description:
      "Private excursion from Cannes to Saint-Paul-de-Vence: ramparts, art galleries, resident artists and the nearby Maeght Foundation.",
    canonical: "/en/excursions/saint-paul-de-vence",
  },
};

export default page;
